export default "__VITE_ASSET__Bb4ruJHw__"